import moment from 'moment';

export default function (timestamp: number | string, dateFormat = 'MM/DD/YYYY hh:mm'): string {
  if (timestamp) {
    return moment(timestamp).format(dateFormat);
  }
}
